import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { SignedEditionSadaicWorkflowStateView } from "./SignedEditionSadaicWorkflowStateView";
import { SignedEditionSadaicWorkflowStateViewStore } from "../../store/SignedEditionSadaicWorkflowStateViewStore";
import { useStore } from "../../../../hooks";

export const SignedEditionSadaicWorkflowStateViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/signedEditionSadaicWorkflowState/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new SignedEditionSadaicWorkflowStateViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <SignedEditionSadaicWorkflowStateView
          signedEditionSadaicWorkflowStateViewStore={store}
        />
      </PageLayout>
    </div>
  );
});
